import type { ButtonHTMLAttributes } from 'react';

import { Icon, type IconName } from '@/components/ui/Icon';
import { cn } from '@/utils/cn';

import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: IconName;
  /** Required: an icon-only button needs a name screen readers can announce. */
  label: string;
  variant?: 'secondary' | 'ghost';
  size?: 'sm' | 'md';
}

export function IconButton({
  icon,
  label,
  variant = 'secondary',
  size = 'md',
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn(styles.button, styles[variant], styles[size], className)}
      {...rest}
    >
      <Icon name={icon} size={size === 'sm' ? 18 : 20} />
    </button>
  );
}
